export default "__VITE_PUBLIC_ASSET__646d95a3__"